module.exports = __webpack_public_path__ + "img/remove-dropdown-icon.a2038876.svg";